import React from 'react';
import { motion } from 'framer-motion';
import { PlaneIcon, BeerIcon, HomeIcon } from 'lucide-react';

/**
 * Social proof.
 *
 * DELIBERATELY CONTAINS NO NUMBERS OR TESTIMONIALS. Nothing here is invented.
 * Once there are genuine Google Play reviews and real usage figures, drop them
 * in below — real quotes with a first name, and real counts from the backend.
 * Never placeholder figures: a made-up number is worse than no number.
 */
const groups = [{
  icon: PlaneIcon,
  label: 'Trips and weekends away'
}, {
  icon: BeerIcon,
  label: 'Nights out and rounds'
}, {
  icon: HomeIcon,
  label: 'Everyday shared plans'
}];
export function SocialProof() {
  return <section className="bg-white py-16 lg:py-20" data-id="element-315" data-mp="3pslh624tfw7s">
      <div className="mx-auto max-w-7xl px-6 sm:px-8" data-id="element-316" data-mp="3ushexjmx6rew">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.45
      }} className="rounded-[2.5rem] bg-[#FFFBF2] px-6 py-12 text-center sm:px-12" data-id="element-317" data-mp="mdpke4b57muc">
          <h2 className="mx-auto max-w-xl text-2xl font-black leading-tight tracking-tight text-kitty-dark md:text-3xl" data-id="element-318" data-mp="1parw7thzp0dw">
            Used by groups for trips, nights out and everyday plans.
          </h2>

          <ul className="mx-auto mt-9 grid max-w-3xl gap-4 sm:grid-cols-3" data-id="element-319" data-mp="1z97mju9705mc">
            {groups.map(group => <li key={group.label} className="flex flex-col items-center gap-3 rounded-2xl bg-white p-6" data-id="element-320" data-mp="2czt51huqidjp">
                <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-kitty-yellow" data-id="element-321" data-mp="283c6ruttmisw">
                  <group.icon className="h-5 w-5 text-kitty-dark" aria-hidden="true" data-id="element-322" data-mp="2mw60ol9ub1h3" />
                </span>
                <p className="text-base font-bold text-kitty-dark" data-id="element-323" data-mp="slajiuklae2p">
                  {group.label}
                </p>
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}